import React from 'react'
import { Table,Button } from 'antd'
import { useSelector,useDispatch } from 'react-redux';
import { move } from '../../stores/actions';

interface IRootState {
    [key: string]: any;
    usersCount: number,
    step: number,
    usersToApprove: any,
}
const ViewUploadedSheet = () => {
    const dispatch = useDispatch();
    const step: any = useSelector<IRootState>(state => state.truckingReducer.step);
    const users: any = useSelector<IRootState>(state => state.actionsReducer.dataSheet.sheetData);
    const columns = [
        {
            title: 'User ID',
            dataIndex: 'userId',
            key: 'userId',
        },
        {
            title: 'Start Date',
            dataIndex: 'startDate',
            key: 'startDate',
        },
        {
            title: 'End Date',
            dataIndex: 'endDate',
            key: 'endDate',
        },
        {
            title: 'Free Deductions',
            dataIndex: 'freeDeductions',
            key: 'freeDeductions',
        },
        {
            title: 'Minimum Installments',
            dataIndex: 'minimumInstallments',
            key: 'minimumInstallments',
        },
    ]
    const submit = async () => {
        dispatch(move(step + 1));
    }
    return (
        <>
            <h3 className='downloaded'>{users?.length} Uploaded User{users?.length > 1 ? "s" : ""}</h3>
            <div className="uploaded" style={{ textAlign: 'center' }}>
                <div className="usersDataTable">
                    <Table columns={columns} dataSource={users} pagination={false} scroll={{ y: "3000px" }} />
                </div>
            </div>
            <div className='flex justify-end gap-5 mt-3 mb-3 '>
                <Button className='ant-btn-primary' onClick={submit} loading={false}>Submit </Button>
                <Button className='reUpload' onClick={() => dispatch(move(0))}>Re-upload the file</Button>
            </div>
        </>
    )
}

export default ViewUploadedSheet